import { formatCurrency } from '@cleanpro/common-ui';
import { useGrowthOps } from '../hooks/useGrowthOps';

interface StatCardProps {
  label: string;
  value: string | number;
  subtext?: string;
  color?: string;
}

function StatCard({ label, value, subtext, color = 'text-gray-900' }: StatCardProps) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-5">
      <p className="text-sm font-medium text-gray-500">{label}</p>
      <p className={`mt-1 text-2xl font-semibold ${color}`}>{value}</p>
      {subtext && <p className="mt-1 text-xs text-gray-400">{subtext}</p>}
    </div>
  );
}

export default function GrowthOpsOverview() {
  const { metrics, loading } = useGrowthOps();

  if (loading || !metrics) {
    return (
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-24 animate-pulse rounded-lg bg-gray-100" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      <StatCard
        label="Growth Providers"
        value={metrics.totalProviders}
        subtext={`${metrics.activeProviders} active · ${metrics.pausedProviders} paused`}
      />
      <StatCard
        label="Total Wallet Balance"
        value={formatCurrency(metrics.totalWalletBalance)}
        color="text-green-700"
      />
      <StatCard
        label="Leads This Week"
        value={metrics.leadsThisWeek}
        subtext={`${formatCurrency(metrics.weeklyRevenue)} revenue`}
      />
      <StatCard
        label="Lifetime Ad Spend"
        value={formatCurrency(metrics.totalLifetimeAdSpend)}
        subtext={`+ ${formatCurrency(metrics.totalLifetimePlatformFee)} platform fees`}
      />
    </div>
  );
}
